import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from "react-select";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import { format, startOfISOWeek, setISOWeek, lastDayOfISOWeek } from "date-fns";

import { Actions as ACTIONS } from "../../store/actions/leaveActions";

const hoursUnderOptions = [
	{
		label: "Ignore",
		value: "",
	},
	{
		label: "Paid Leave",
		value: "leave",
	},
	{
		label: "Unpaid Leave",
		value: "unpaid",
	},
	{
		label: "TOIL",
		value: "toil",
	},
	{
		label: "Split",
		value: "split",
	},
];

const calculateTotalHours = (obj) => {
	console.log("obj", obj);
	let total = 0;
	Object.keys(obj).map((key) => {
		const number = isNaN(parseFloat(obj[key])) ? 0 : parseFloat(obj[key]);
		total += number;
	});
	return total;
};

const getDateOfISOWeek = (w, y) => {
	var simple = new Date(y, 0, 1 + (w - 1) * 7);
	var dow = simple.getDay();
	var ISOweekStart = simple;
	if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
	else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
	return ISOweekStart;
};

const weeklyKeysToUse = (key, lastDate) => {
	const keyParts = key.split(".");

	const date = getDateOfISOWeek(keyParts[1], keyParts[0]);
	date.setDate(date.getDate() + 6);

	return date <= new Date(lastDate);
};

const HourRow = ({ item, index, isWeekly, isMonthly, employeeLeaveBalance, employee }) => {
	const [confirmed, setConfirmed] = useState(true);
	const [selected, setSelected] = useState({
		label: "Ignore",
		value: "",
	});

	const [balances, setBalances] = useState({
		leave: 0,
		unpaid: 0,
		toil: 0,
	});

	useEffect(() => {
		if (confirmed) {
			const currentUnderHours = localStorage.getItem("timesheetUnderHours");

			const currentUnderHoursObject = (currentUnderHours && JSON.parse(currentUnderHours)) || {};

			currentUnderHoursObject[item.agreement] = balances;

			localStorage.setItem("timesheetUnderHours", JSON.stringify(currentUnderHoursObject));
		}
	}, [confirmed]);

	// console.log("drawing Row",item,item.month,index)

	{
		/*const item = data[warning.agreement];*/
	}
	const rowClass = index % 2 == 1 ? "odd" : "even";

	const {
		hoursWorked,
		hoursDifference,
		targetHours,
		hasMultipleSalaries,
		weeklyBreakdown,
		terminated,
		engaged,
		isExactPay,
		weeklyDifferenceBreakdown,
		weeklyDifference,
	} = item.hoursUnderData;

	const remainingAfterBalances = parseFloat((hoursDifference - calculateTotalHours(balances)).toFixed(2));
	const hoursDifferenceStyle = remainingAfterBalances == 0 ? { color: "#00bb87" } : { color: "#e83e36" };

	const updateBalances = (e) => {
		console.log("event", e.target.value, e.target.name);

		const newBalances = { ...balances };

		newBalances[e.target.name] = e.target.value;

		if (isWeekly) {
			delete newBalances.breakdown;
			const balanceKeys = Object.keys(newBalances);
			newBalances.breakdown = {};
			Object.keys(weeklyDifferenceBreakdown).map((key) => {
				// for each week apply proportion of the value in each newBalance Key excluding breakdown
				const proportion = weeklyDifferenceBreakdown[key] / weeklyDifference;
				balanceKeys.map((balanceKey) => {
					// if (balanceKey != 'breakdown'){
					newBalances.breakdown[key] = newBalances.breakdown[key] || {};
					newBalances.breakdown[key][balanceKey] = (proportion * newBalances[balanceKey]).toFixed(2);
					// }
				});
			});
			console.log("newBalances", newBalances);
		}

		setBalances(newBalances);
		setConfirmed(false);
	};

	const selectHoursUnderOptions = (
		<Select
			style={{ maxWidth: "125px" }}
			value={selected}
			onChange={(selectedOption) => {
				console.log("updateSelected", selectedOption, balances);

				setSelected(selectedOption);

				if (selectedOption.value !== "split") {
					const newBalances = {
						leave: 0,
						unpaid: 0,
						toil: 0,
					};

					if (selectedOption.value !== "") newBalances[selectedOption.value] = hoursDifference.toFixed(2);

					if (isWeekly) {
						delete newBalances.breakdown;
						const balanceKeys = Object.keys(newBalances);
						newBalances.breakdown = {};
						Object.keys(weeklyDifferenceBreakdown).map((key) => {
							// for each week apply proportion of the value in each newBalance Key excluding breakdown
							const proportion = weeklyDifferenceBreakdown[key] / weeklyDifference;
							balanceKeys.map((balanceKey) => {
								// if (balanceKey != 'breakdown'){
								newBalances.breakdown[key] = newBalances.breakdown[key] || {};
								newBalances.breakdown[key][balanceKey] = (proportion * newBalances[balanceKey]).toFixed(
									2,
								);
								// }
							});
						});
						console.log("newBalances", newBalances);
					}
					setBalances(newBalances);
				}

				setConfirmed(false);

				// TODO save in local storage for persistance
			}}
			options={hoursUnderOptions}
		/>
	);

	const nameStyle = {};

	if (hasMultipleSalaries) {
		nameStyle.color = "#ea611c";
	}

	const mainRow = (
		<tr
			key={item.agreement}
			role="row"
			className={rowClass}
		>
			<td
				className="font-w600"
				style={nameStyle}
			>
				{employee?.fullName}
				{hasMultipleSalaries && <sup>2</sup>}
				<br />
				{employee?.roleName} - {employee?.employmentTypeName}
			</td>
			<td>
				{employeeLeaveBalance &&
					employeeLeaveBalance.balanceThisYearWithFutureLeave &&
					employeeLeaveBalance.balanceThisYearWithFutureLeave.toFixed(2)}
			</td>
			<td>
				{employeeLeaveBalance &&
					employeeLeaveBalance.balanceToDate &&
					employeeLeaveBalance.balanceToDate.toFixed(2)}
			</td>
			<td>{(targetHours && targetHours.toFixed(2)) || 0}</td>
			<td>{(hoursWorked && hoursWorked.toFixed(2)) || 0}</td>
			<td style={hoursDifferenceStyle}>
				{selected.value == "split" ? remainingAfterBalances.toFixed(2) : hoursDifference.toFixed(2)}
			</td>
			<td>{selectHoursUnderOptions}</td>
			<td colSpan="1">
				<div
					className={`btn btn-${confirmed ? "default" : "success"}`}
					onClick={() => {
						setConfirmed(true);
					}}
					style={confirmed ? { opacity: 0.5, cursor: "default" } : {}}
				>
					{confirmed ? "Prepared" : "Confirm"}
				</div>
				{/*<label className="css-input css-checkbox css-checkbox-success check-ready" onClick={() => {setConfirmed(!confirmed)}}>
                <input type="checkbox" className="ready" checked={confirmed}/>
                <span />
                Ready
              </label>*/}
			</td>
		</tr>
	);

	if (selected.value != "split") {
		return [mainRow].concat(weeklyBreakdown);
	} else {
		const breakdown = ["leave", "unpaid", "toil"].map((type) => (
			<tr
				key={item.agreement + "." + type}
				role="row"
				className={rowClass}
			>
				<td className="font-w600"></td>
				<td className="font-w600">{_.find(hoursUnderOptions, { value: type }).label}</td>
				<td>
					<input
						style={{ maxWidth: "50px" }}
						name={type}
						value={balances[type]}
						onChange={updateBalances}
					/>
				</td>
				<td colSpan="1">
					{type == "toil" && (
						<div
							className="btn btn-success"
							onClick={() => {
								setConfirmed(true);
							}}
							style={confirmed ? { opacity: 0.5 } : {}}
						>
							Confirm
						</div>
					)}
					{/*<span onClick={() => {
                const newCollapse = {...collapse}
                newCollapse[item.agreement] = !collapse[item.agreement]
                setCollapse(newCollapse);
              }}>{collapse[item.agreement] ? 'Collapse' : 'Expand'}</span>*/}
				</td>
				<td></td>
			</tr>
		));
		return [mainRow].concat(breakdown).concat(weeklyBreakdown);
	}
};

const mapStateToProps = (state, ownProps) => {
	const { item } = ownProps;

	const leaveBalances = state.leave.leaveBalances;

	const employee =
		(state.payroll &&
			state.payroll.employees &&
			state.payroll.employees.find((employee) => employee.id == item.agreement)) ||
		{};

	const employeeLeaveBalance = leaveBalances && leaveBalances.find((leave) => leave.agreementId == item.agreement);

	return {
		employee,
		employeeLeaveBalance,
		payPeriodDetails: state.payroll.payPeriodDetails,
		alwaysExactHours: state.company?.settings?.alwaysExactHours,
	};
};

const mapDispatchToProps = (dispatch) => ({
	// leaveGetBalances: (until) => dispatch(ACTIONS.leaveGetBalances(until)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HourRow);
